/**
 * Generates a simple, stable hash for Fedwire transfer reference.
 * @param {string} accountNumber
 * @returns {string}
 */
export const generateReferenceHash = (accountNumber) => {
  if (!accountNumber) return 'NYB-FW-7FD9A';
  
  // Simple deterministic hash based on accountNumber
  let hash = 0;
  const str = String(accountNumber);
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }
  const hex = Math.abs(hash).toString(16).toUpperCase().substring(0, 6);
  return `NYB-FW-${hex}`;
};
